module.exports = __webpack_public_path__ + "img/form_disabled.d0033fa4.svg";